import React, { useMemo, useState, useEffect } from 'react';
import { Badge } from '@mantine/core';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { getWaterRightsListQuery } from '../../../../slices/waterRights/thunk';
import { getEstablishmentTypeList } from '../../../../helpers/establishment/backend_helper';

const WaterRightsDashboardGrid = () => {
	const [estTypeMap, setEstTypeMap] = useState({});

	useEffect(() => {
		getEstablishmentTypeList()
			.then(res => {
				const types = Array.isArray(res) ? res : (res?.data || []);
				const map = {};
				types.forEach(t => { map[t._id] = t.name; });
				setEstTypeMap(map);
			})
			.catch(() => { });
	}, []);

	const getStatusColor = status => {
		if (!status) return 'gray';
		const s = status.toLowerCase();
		if (s.includes('otorgado')) return 'green';
		if (s.includes('trámite')) return 'yellow';
		if (s.includes('caducado') || s.includes('cancelado')) return 'red';
		return 'cyan';
	};

	const columns = useMemo(() => [
		{
			header: 'Estado',
			dataType: 'select',
			accessorKey: 'water_rights_status.name',
			Cell: cellProps => {
				const status = cellProps.row.original.water_rights_status?.name;
				return (
					<Badge color={getStatusColor(status)} tt='capitalize'>
						{status || '-'}
					</Badge>
				);
			},
		},
		{
			header: 'Tipo de Establecimiento',
			dataType: 'string',
			accessorKey: 'establishment.establishment_type_id',
			Cell: cellProps => {
				const typeId = cellProps.row.original.establishment?.establishment_type_id;
				return <span>{estTypeMap[typeId] || '-'}</span>;
			},
		},
		{
			header: 'Establecimiento',
			dataType: 'string',
			accessorKey: 'establishment.name',
		},
		{
			header: 'N° Resolución',
			dataType: 'string',
			accessorKey: 'resolution_number',
		},
		{
			header: 'Tipo de Derecho',
			dataType: 'select',
			accessorKey: 'water_right_type.name',
		},
		{
			header: 'Fuente de Agua',
			dataType: 'multi-select',
			accessorKey: 'water_sources',
			Cell: cellProps => {
				const sources = cellProps.row.original.water_source;
				if (!Array.isArray(sources) || sources.length === 0) return '-';
				return <span>{sources.map(ws => ws.name).join(', ')}</span>;
			},
		},
	], [estTypeMap]);

	return (
		<ODataGrid
			columns={columns}
			getDataFunc={getWaterRightsListQuery}
			baseFilters={{ disable: { $eq: false } }}
			queryPopulate={['establishment', 'water_rights_status', 'water_right_type', 'right_exercise_type', 'water_source']}
			remoteOperations={{ pagination: true, sorting: true, filtering: true }}
			getRowIdTable={row => row._id}
			nameFile='derechos_de_agua_dashboard'
		/>
	);
};

export default WaterRightsDashboardGrid;
